var map = {
	"./editorBaseApi": [
		93059
	],
	"./editorBaseApi.js": [
		93059
	],
	"./editorSimpleWorker": [
		93034
	],
	"./editorSimpleWorker.js": [
		93034
	],
	"./editorWorker": [
		90304
	],
	"./editorWorker.js": [
		90304
	],
	"./editorWorkerHost": [
		96358
	],
	"./editorWorkerHost.js": [
		96358
	],
	"./findSectionHeaders": [
		99307
	],
	"./findSectionHeaders.js": [
		99307
	],
	"./getIconClasses": [
		78148
	],
	"./getIconClasses.js": [
		78148
	],
	"./languageFeatureDebounce": [
		12060
	],
	"./languageFeatureDebounce.js": [
		12060
	],
	"./languageFeatures": [
		52230
	],
	"./languageFeatures.js": [
		52230
	],
	"./languageFeaturesService": [
		97259
	],
	"./languageFeaturesService.js": [
		97259
	],
	"./languageService": [
		83930
	],
	"./languageService.js": [
		83930
	],
	"./languagesAssociations": [
		55996
	],
	"./languagesAssociations.js": [
		55996
	],
	"./languagesRegistry": [
		66995
	],
	"./languagesRegistry.js": [
		66995
	],
	"./markerDecorations": [
		80886
	],
	"./markerDecorations.js": [
		80886
	],
	"./markerDecorationsService": [
		90011
	],
	"./markerDecorationsService.js": [
		90011
	],
	"./model": [
		64830
	],
	"./model.js": [
		64830
	],
	"./modelService": [
		40931
	],
	"./modelService.js": [
		40931
	],
	"./resolverService": [
		37042
	],
	"./resolverService.js": [
		37042
	],
	"./semanticTokensDto": [
		19376
	],
	"./semanticTokensDto.js": [
		19376
	],
	"./semanticTokensProviderStyling": [
		38620
	],
	"./semanticTokensProviderStyling.js": [
		38620
	],
	"./semanticTokensStyling": [
		5272
	],
	"./semanticTokensStyling.js": [
		5272
	],
	"./semanticTokensStylingService": [
		38148
	],
	"./semanticTokensStylingService.js": [
		38148
	],
	"./textModelSync/textModelSync.impl": [
		55526
	],
	"./textModelSync/textModelSync.impl.js": [
		55526
	],
	"./textModelSync/textModelSync.protocol": [
		45628,
		121
	],
	"./textModelSync/textModelSync.protocol.js": [
		45628,
		121
	],
	"./textResourceConfiguration": [
		41504
	],
	"./textResourceConfiguration.js": [
		41504
	],
	"./treeSitterParserService": [
		35320
	],
	"./treeSitterParserService.js": [
		35320
	],
	"./treeViewsDnd": [
		2603
	],
	"./treeViewsDnd.js": [
		2603
	],
	"./treeViewsDndService": [
		26756
	],
	"./treeViewsDndService.js": [
		26756
	],
	"./unicodeTextModelHighlighter": [
		49887
	],
	"./unicodeTextModelHighlighter.js": [
		49887
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9204;
module.exports = webpackAsyncContext;